import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { colors, md, sans } from '../common'

const Btn = ({ link, nav, text, color = 'white', fontSize = '14px', btnStyle = '' }) => {
  if (link !== undefined) {
    return(
      <div>
      <StyledLink to={link}>
        <StyledButton color={color} fontSize={fontSize} btnStyle={btnStyle}>
          <BtnText fontSize={fontSize}>{text}</BtnText>
        </StyledButton>
      </StyledLink>
      </div>
    )
  } else {
    return(
      <Link to={`/products/${nav}`}>
        <StyledDiv>
          <StyledButton color={color} fontSize={fontSize} btnStyle={btnStyle}>
            <BtnText fontSize={fontSize}>{text}</BtnText>
          </StyledButton>
        </StyledDiv>
      </Link>
    )
  }
}

const StyledLink = styled(Link)`
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;

  :hover {
    color: white;
  }
`

const StyledDiv = styled.div`
  text-transform: uppercase;
  width: 100%;
  cursor: pointer;

  :hover {
    color: white;
  }
`


export const StyledButton = styled.div`
  padding: 1rem;
  background-color: ${ props => props.color };
  color: ${colors.brownDark};
  border: 1px solid ${colors.brownLight};
  letter-spacing: 2px;
  ${sans};
  text-align: center;
  color: ${colors.brownDark};
  ${ props => props.btnStyle};

  :hover {
    background-color: ${colors.brownLight};
    color: white;
  }

  ${md} {
    padding: 1rem;
    width: auto;
  }
`

const BtnText = styled.span`
  margin: auto;
  text-transform: uppercase;
  font-size: ${ props => props.fontSize };
`

export default Btn
